module.exports = __webpack_public_path__ + "img/icon_3.2c6086fb.svg";